import React, { FunctionComponent } from 'react';
import ReactTooltip from 'react-tooltip';
import ButtonLink from '../../Buttons/ButtonLink';
import Section from '../../Section';
import SimpleTable from '../../Table/SimpleTable';
import { TCase } from '../../../store/case/types';
import SimpleLoader from '../../SimpleLoader';
import NoData from '../NoData';
import { TTicket } from 'store/ticket/types';

interface IOwnProps {
  tickets: TTicket[];
  loading: boolean;
}
const OpenTicketsTable: FunctionComponent<IOwnProps> = ({ tickets, loading }) => {

  const rows = tickets.map((item, index) => (
    <tr key={`Account Open Tickets${index}`} className={`text-light${index < tickets.length - 1 ? ' border-bottom' : ''}`}>
      <td className="pl-4" style={{ verticalAlign: 'middle', minWidth: '200px' }}>{item.ticketNumber}</td>
      <ReactTooltip />
      <td className="pl-4" style={{ verticalAlign: 'middle' }} data-tip={item.title.length > 50 ? item.title : ''} data-delay-show="250">{item.title.length > 50 ? `${item.title.substring(0, 50)}...` : item.title}</td>
      <td className="d-flex justify-content-end pr-4" style={{ minWidth: '150px' }}><ButtonLink color="light" text="View Ticket" textColor="white" url={`/tickets/${item.id}`} /></td>
    </tr>
  ));
  return (
    <div>
      <Section
        title="Open Tickets"
        children={(
          <SimpleLoader loading={loading}>
            {tickets.length < 1 && (<NoData text="No open tickets at present" />)}
            {tickets.length > 0 && (<SimpleTable rows={rows} />)}
          </SimpleLoader>
)}
      />
    </div>
  );

};
export default OpenTicketsTable;
